import { render } from "./Step_2.vue?vue&type=template&id=a374d8c6"
import script from "./Step_2.vue?vue&type=script&lang=js"
export * from "./Step_2.vue?vue&type=script&lang=js"

import "./Step_2.vue?vue&type=style&index=0&id=a374d8c6&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__